import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actions from 'actions';
import _ from 'lodash';

const {
  loadCurrentUser,
  updateUrlUser
} = actions;

import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
class Main extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.checkUrl();
  }

  checkUrl() {
    const query = this.props.location.search.slice(1);

    if (/token=/.test(query) && /&ID=/.test(query)) {
      const urlArray = query.split('&');
      const id = urlArray[1].slice(3);
      const token = urlArray[0].slice(6);
      this.props.updateUrlUser({id: id, token: token});
    } else {
      this.props.loadCurrentUser();
    }
  }
  render() {
    return (
      <div className="app">
        <Navbar push={this.props.router.push} pathname={this.props.location.pathname} q={this.props.location.query.q} />
          {this.props.children}
        { this.props.role != 'admin' && <Footer isOnLanding={this.props.location.pathname === '/'} /> }
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  role: state.users.user.role
});

const mapDispatchToProps = (dispatch) => ({
  loadCurrentUser: () => dispatch(loadCurrentUser()),
  updateUrlUser: (data) => dispatch(updateUrlUser(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);



// WEBPACK FOOTER //
// ./src/containers/App/App.js